const File = [
  { type: 'item', text: 'Close' },
];

const View = [
  { type: 'item', disable: true, text: 'Details' },
  { type: 'item', disable: true, text: 'Thumbnails' },
];

const Help = [
  { type: 'item', disable: true, text: 'About mahip.exe' },
];

export default { File, View, Help };
